/**
 * Verifica si el valor es númerico
 * @param {*} value 
 * @returns 
 */
 const isNumeric = (value) => {
    if (value) {
      const result = value.replace(/\./g, '');
      return /^-?\d+$/.test(result);
    }
    return false;
  }

  const generateRamdomNumber = ()=>{
    return Math.random();
  }
  
export const numberFunctionHelpers = {
    isNumeric: isNumeric,
    generateRamdomNumber: generateRamdomNumber
}